import { render, staticRenderFns } from "./productItem.vue?vue&type=template&id=6617012c&"
import script from "./productItem.vue?vue&type=script&lang=js&"
export * from "./productItem.vue?vue&type=script&lang=js&"
import style0 from "./productItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports